import { getApi } from "../apiCall";

export const getGeneratorList = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/generators`;
  return getApi(url);
};

export const getConsumersList = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/consumers`;
  return getApi(url);
};

export const getDiscomsList = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/discoms`;
  return getApi(url);
};

export const getCompanyList = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/company`;
  return getApi(url);
};

export const getAllConsumerUserList = (consumerId) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/consumers/${consumerId}/users`;
  return getApi(url);
};

export const getAllGeneratorUserList = (generatorId) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/generators/${generatorId}/users`;
  return getApi(url);
};

export const getAllPermissionUserList = (userId) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/users/${userId}/permissions`;
  return getApi(url);
};

export const getAllPermissionList = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/permission/getAllByType?permissionTypes=ROLE`;
  return getApi(url);
};

export const getConsumerDetails = (consumerId) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/consumerDetails/consumer/${consumerId}/details`;
  return getApi(url);
};

export const getGeneratorDetails = (generatorId) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/generatorDetails/generator/${generatorId}/details`;
  return getApi(url);
};

export const getCompanyUsers = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company/${id}/users`;
  return getApi(url);
};

export const getAllEntityUserList = ({ role, id }) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company-admin/${role}s/${id}/users`;
  return getApi(url);
};
